<section>
  <h2 class="mb-3" tabindex="0" nessAutoFocus>{{ addressOrLocation }} details</h2>
  <ng-container *removeIfNoPermission="canEdit">
    <a *ngIf="showEditButton" class="btn btn-active mb-2 me-2" (click)="editLocation()">Edit location</a>
  </ng-container>
  <button type="button" *ngIf="showDeleteButton" class="btn btn-active mb-2" (click)="deleteLocation()">Delete location</button>
  <div class="card">
    <div class="card-body">
      <p-messages key="locationDetailMsg" [closable]="true"></p-messages>
      <div class="row gy-2 gx-3 align-items-center m-2">
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end" *ngIf="personDetailAddress">Person address type:</div>
        <div class="col-lg-8 col-md-7" *ngIf="personDetailAddress">{{ personAddressType }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Consolidated address:</div>
        <div class="col-lg-8 col-md-7">{{ consolidatedAddressFormatter(addressDTO.ConsolidatedAddressReturned) }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end" *ngIf="!personDetailAddress">Location type:</div>
        <div class="col-lg-8 col-md-7" *ngIf="!personDetailAddress">{{ addressDTO.LocationType }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Street address:</div>
        <div class="col-lg-8 col-md-7"> {{addressDTO.StreetAddress }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Unit:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.Unit }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">City:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.CityName }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">State:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.ENESS_REF_State?.StateName }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Postal code:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.PostalCode }} {{ addressDTO.PostalCodeExtended }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Police department:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.PoliceDepartment }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Police department sub area 1 (district):</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.PoliceDepartmentSubArea1 }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Police department sub area 2 (zone):</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.PoliceDepartmentSubArea2 }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Notes:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.AnalystNotes | sanitizeHtml }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Entered longitude:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.EnteredLongitude }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Entered latitude:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.EnteredLatitude }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Captured longitude:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.CapturedLongitude }}</div>
        <div class="col-lg-4 col-md-5 text-xs-start text-md-end">Captured latitude:</div>
        <div class="col-lg-8 col-md-7">{{ addressDTO.CapturedLatitude }}</div>
      </div>
    </div>
    <div class="card-body">
      <div class="card-title"><h3>NESS Associations</h3></div>
      <div class="table-responsive">
        <table class="temp-bs table table-sm table-striped table-bordered">
          <caption class="caption-top form-label text-body fw-bold">People</caption>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">DOB</th>
              <th scope="col">Sex</th>
              <th scope="col">Person Address Type</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="locationService.addressPeople$ | async as addressPeople;else loadingPeople">
              <tr *ngIf="addressPeople == null || addressPeople.length == 0"><td colspan="4">No people found.</td></tr>
              <tr *ngFor="let adp of addressPeople">
                <th scope="row">{{ adp.FirstName }} {{ adp.LastName }}</th>
                <td>{{ adp.DateOfBirth | date:"MM/dd/yyyy" }}</td>
                <td>{{ adp.Gender }}</td>
                <td>{{ adp.AddressType}}<span *ngIf="adp.AddressType == 'Other'">: {{adp.OtherAddressType}}</span></td>
              </tr>
            </ng-container>
            <ng-template #loadingPeople>
              <tr>
                <td colspan="4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
      <div class="table-responsive">
        <table class="temp-bs table table-sm table-striped table-bordered">
          <caption class="caption-top form-label text-body fw-bold">LE cases</caption>
          <thead>
            <tr>
              <th scope="col">Event LE case #</th>
              <th scope="col">LE agency</th>
              <th scope="col">Event crime type</th>
              <th scope="col">Event date</th>
              <th scope="col">Crime Gun ID(s)</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="locationService.addressLECases$ | async as addressLECases;else loadingLeCases">
              <tr *ngIf="addressLECases == null || addressLECases.length == 0"><td colspan="5">No LE cases found.</td></tr>
              <tr *ngFor="let lcn of addressLECases">
                <td>{{ lcn.LECaseNumber }}</td>
                <td>{{ lcn.AgencyName }}</td>
                <td>{{ lcn.CrimeTypeName }}</td>
                <td>{{ lcn.EventDate | date:"MM/dd/yyyy" }}</td>
                <td>
                  <ul class="list-unstyled" *ngIf="lcn.RelatedCrimeGunNumbers">
                    <li class="text-nowrap" *ngFor="let cg of lcn.RelatedCrimeGunNumbers.split(','); index as i">
                      <a (click)="openRelatedCrimeGun($event, cg)">{{ cg }}</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </ng-container>
            <ng-template #loadingLeCases>
              <tr>
                <td colspan="5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<p-dialog header="Delete comment" [(visible)]="showDeleteHistoryForm" appendTo="body" [draggable]="false" [modal]="true" [resizable]="true" styleClass="deleteDialog" [baseZIndex]="3" [style]="{width: '50vw'}" [breakpoints]="{'992px': '75vw', '576px': '90vw'}">
  <ness-delete-history-form [targetId]="deleteHistoryTargetId" [targetTable]="deleteHistoryTargetTableName" (deleteHistorySubmitted)="onDeleteHistorySubmitted($event)" (closeForm)="showDeleteHistoryForm = false"></ness-delete-history-form>
</p-dialog>

